module.exports = __webpack_public_path__ + "img/img5.9c9daa1a.png";